import { makeClassName } from '@siteless/util';
import { IconPropsType } from '../util/types';

let SearchIcon = ({ className, ...rest }: IconPropsType) => (
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    xmlSpace="preserve"
    {...rest}
    className={makeClassName('SearchIcon', className)}
  >
    <circle
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      cx="11"
      cy="11"
      r="8"
    />
    <line
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      x1="21"
      y1="21"
      x2="16.65"
      y2="16.65"
    />
  </svg>
);

export default SearchIcon;
